/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineDataTableHelper() {
		var dataTableHelper = {};
		dataTableHelper.castFieldValues = function (data) {
			for(var i = 0; i < data.length; i++){
				var keys = Object.keys(data[i]);
				for(var j = 0; j < keys.length; j++){
					var key = keys[j];
					var value = data[i][key];
					if (castingUtility.isValueBoolean(value)){
						data[i][key] = castingUtility.booleanToString(value);
					}
					//check to see if value is date and convert to date format
					if(moment(value, moment.ISO_8601).isValid()){
						data[i][key] = moment(value, moment.ISO_8601).format("DD/MM/YYYY");
						//data[i][key] = moment(new Date(value), moment.ISO_8601).format("DD/MM/YYYY");
					}
				}
			}
			return data;
		};
		dataTableHelper.castObjectValues = function(data){
			var keys = Object.keys(data);
			for(var i = 0; i < keys.length; i++){
				var key = keys[i];
				var value = data[key];
				if (castingUtility.isValueBoolean(value)){
					data[key] = castingUtility.booleanToString(value);
				}
				//check to see if value is date and convert to date format
				if(moment(value, moment.ISO_8601).isValid()){
					data[key] = moment(value, moment.ISO_8601).format("DD/MM/YYYY");
					//data[i][key] = moment(new Date(value), moment.ISO_8601).format("DD/MM/YYYY");
				}
			}
			return data;
		};
		return dataTableHelper;
	}

	if (typeof (dataTableHelper) === "undefined") {
		window.dataTableHelper = defineDataTableHelper();
	} else {
		console.log("dataTableHelper already defined.");
	}
})(window);
